/*###########################################################################
// App
//#########################################################################*/

/* CSS
//------------------*/

import "@css/app.css";

/* App
//------------------*/

window.app = {
  disableScroll() {
    document.documentElement.style.overflow = 'hidden'
  },

  enableScroll() {
    document.documentElement.style.overflow = ''
  }
}

/* Utilities
//------------------*/

import '@js/utilities/_initComponent'

/* Components
//------------------*/

import '@js/components/index'

/* Vendor
//------------------*/

import '@js/vendor/index'

/**
 * Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR");
  });
}

// Barba / Lenis
import { animate } from "motion"
import barba from '@barba/core';
import Lenis from 'lenis'
import { scrollTo } from './utilities/_scrollTo'

window.lenis = new Lenis({
	syncTouch: true,
	lerp: 0.125
})

window.addEventListener('load', function () {
  window.lenis.on('scroll', (e) => {
    // console.log(e)
  })

  function raf(time) {
    window.lenis.raf(time)
    requestAnimationFrame(raf)
  }

  requestAnimationFrame(raf)
})

const pageTransitionDot = document.querySelector('.pageTransition__dot')

barba.init({
	transitions: [{
		sync: true,
		name: 'opacity-transition',
		beforeLeave(data) {
			const beforeEnterEvent = new CustomEvent('before-page-change')
			window.dispatchEvent(beforeEnterEvent)

			pageTransitionDot.style.opacity = 1
			pageTransitionDot.classList.add('pageTransition__dot--active')
		},
		enter(data) {
			if (window.lenis !== undefined) {
				window.lenis.stop()
			}

			setTimeout(function() {
				window.scrollTo(0, 0)
			}, 500)

			setTimeout(function() {
				if (window.lenis !== undefined) {
					window.lenis.start()
				}
			}, 1000)
		},
		after(data) {
			const enterEvent = new CustomEvent('page-change')
			window.dispatchEvent(enterEvent)

			setTimeout(function() {
				pageTransitionDot.classList.remove('pageTransition__dot--active')

				setTimeout(function() {
					pageTransitionDot.style.opacity = 0
				}, 500)
			}, 500)
		},
		afterEnter({ trigger }) {
			const afterEnterEvent = new CustomEvent('after-page-change')
			window.dispatchEvent(afterEnterEvent)

			setTimeout(function() {
				if (trigger && trigger.hash) {
					const target = document.querySelector(trigger.hash)

					if (target !== null) {
						const offsetAmount = document.querySelector('.header').clientHeight + (window.innerWidth < 1024 ? 140 : 80)
						scrollTo(target, -offsetAmount)
					}
				}
			}, 1500)
		}
	}],
	preventRunning: true,
	timeout: 7500,
	prevent: ({ href }) => {
    // Prevent if the link's href matches the current page URL
		if (href === window.location.href) {
			return true
		}

		// Disable incoming and outgoing barba for specific slug
		// if (window.location.href.indexOf('slug') !== -1) {
		// 	return true
		// } else if (href.indexOf('slug') !== -1) {
		// 	return true
		// }
  }
})

barba.hooks.leave(() => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve()
    }, 250)
  })
})

barba.hooks.beforeEnter(({ next }) => {
	setTimeout(() => {
		if (typeof htmx !== 'undefined') {
			htmx.process(next.container)
		}
	}, 250)
})
